import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import routes from './routerConfig.js'
import axios from 'axios'
import store from './store.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueCookies from 'vue-cookies'


Vue.use(VueCookies)
Vue.use(VueRouter);
Vue.use(ElementUI);

const router = new VueRouter({
  routes
});

// router.beforeEach((to, from, next) => {
//   if (to.name == 'Index' || to.name == 'Login' || to.name == 'Order' || to.name == 'qrCode') {
//     next();
//   }
//   if (to.name == 'Admin' || to.name == 'CardTable' || to.name == 'OrderList') {
//     if (!store.getters.login) {
//       router.push({
//         name: 'Login'
//       })
//     } else {
//       next();
//     }
//   }
// })

Vue.prototype.$http = axios;
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js